import React from 'react';
import { FileText } from 'lucide-react';

/**
 * AppFooter - Footer component for internal pages (dashboard, reports, etc.)
 * NOT used on the landing page
 */
const AppFooter = () => {
  // Inline style to override browser default link colors
  const linkStyle = {
    color: '#fb923c', // orange-400
    textDecoration: 'none'
  };
  
  const linkHoverStyle = {
    color: '#fed7aa' // orange-200
  };

  return (
    <footer className="px-6 py-12 bg-gray-600 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-sky-500 to-orange-500 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-white">Career Support</span>
            </div>
            <p style={{ color: '#fb923c' }}>
              AI-powered career tools to help you land your dream job.
            </p>
          </div>
          
          {/* Features */}
          <div>
            <h4 className="text-white font-semibold mb-4">Features</h4>
            <ul className="space-y-2">
              <li><a href="/templates" style={linkStyle} className="hover:opacity-80 transition-opacity">Resume Templates</a></li>
              <li><a href="/jobs" style={linkStyle} className="hover:opacity-80 transition-opacity">Job Search</a></li>
              <li><a href="/interview-prep" style={linkStyle} className="hover:opacity-80 transition-opacity">Interview Prep</a></li>
              <li><a href="/salary-analyzer" style={linkStyle} className="hover:opacity-80 transition-opacity">Salary Analyzer</a></li>
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li><a href="/help" style={linkStyle} className="hover:opacity-80 transition-opacity">Help Center</a></li>
              <li><a href="/faq" style={linkStyle} className="hover:opacity-80 transition-opacity">FAQ</a></li>
              <li><a href="/contact" style={linkStyle} className="hover:opacity-80 transition-opacity">Contact Us</a></li>
              <li><a href="/resources" style={linkStyle} className="hover:opacity-80 transition-opacity">Career Resources</a></li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><a href="/careers" style={linkStyle} className="hover:opacity-80 transition-opacity">Careers - We&apos;re Hiring!</a></li>
              <li><a href="/partnerships" style={linkStyle} className="hover:opacity-80 transition-opacity">Become a Partner</a></li>
              <li><a href="/privacy" style={linkStyle} className="hover:opacity-80 transition-opacity">Privacy Policy</a></li>
              <li><a href="/terms" style={linkStyle} className="hover:opacity-80 transition-opacity">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="border-t border-gray-400 pt-8 text-center">
          <p className="text-white">&copy; 2025 Career Support. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
